export default {
  borderRadius: '10px',

  cardBorderRadius: '10px',

  tabButtonBorderRadius: '30px'
};
